import { ChakraProvider } from '@chakra-ui/react';
import { extendTheme } from "@chakra-ui/react";
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import * as React from 'react';
import { reactPlugin } from './appInsights';

const theme = extendTheme({
    colors: {
        brand: {
            900: "#a32b29",
            800: "#811a1b",
            700: "#c56969",
            600: "#dd8d8d",
            500: "#ffffff",
            400: "#444444",
            300: "#636466",
            50: "#f4f0f0"
        },
    },
    fontSizes: {
        base: "14px",
        xs: "12px",
        sm: "14px",
        md: "16px"
    },
    styles: {
        global: {
            'html, body': {
                fontSize: 'sm',
                fontFamily: 'ui-sans-serif,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Helvetica,Apple Color Emoji,Arial,Segoe UI Emoji,Segoe UI Symbol',
                backgroundColor:'#ffffff'
            },
            // styles for the `body`
            '::-webkit-scrollbar': {
                width: '10px'
            },
            '::-webkit-scrollbar-track': {
                bgColor: '#f1f1f1',
                borderRadius: 5
            },
            '::-webkit-scrollbar-thumb': {
                bgColor: '#888888',
                borderRadius: 5
            },
            '::-webkit-scrollbar-thumb:hover': {
                bgColor: '#555555'
            }
        }
    },
    components: {
        Button: {
            baseStyle: {
                fontWeight: "medium",
                borderRadius: "md",
            },
            variants: {
                brand: {
                    bg: "brand.900",
                    color: "white",
                    _hover: {
                        bg: "brand.800",
                    },
                    _active: {
                        bg: "brand.900",
                    },
                    _disabled: {
                        bg: "gray.400",
                        color: "gray.200",
                        cursor: "not-allowed",
                        opacity: 0.6,
                        _hover: {
                            bg: "gray.200",
                            color: "gray.200",
                        },
                    },
                },
                cancel: {
                    bg: "brand.300",
                    color: "white",
                    _hover: {
                        bg: "brand.400",
                    },
                    _active: {
                        bg: "brand.300",
                    },
                    _disabled: {
                        bg: "gray.400",
                        color: "gray.200",
                        cursor: "not-allowed",
                        opacity: 0.6,
                        _hover: {
                            bg: "gray.200",
                            color: "gray.200",
                        },
                    },
                },
            },
            defaultProps: {
                colorScheme: "brand",
            },
        },
        Radio: {
            baseStyle: {
                control: {
                    _checked: {
                        bg: "brand.900",
                        borderColor: "brand.900",
                        _hover: {
                            bg: "brand.800",
                            borderColor: "brand.800",
                        },
                    },
                },
            },
        },
    },
})

export function Providers({
    children
}: {
    children: React.ReactNode
}) {
    return (
        <ChakraProvider theme={theme}>
            <AppInsightsContext.Provider value={reactPlugin}>
                {children}
            </AppInsightsContext.Provider>
        </ChakraProvider>
    )
}